module.exports = __webpack_public_path__ + "img/iphone.8348c228.svg";